import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import TextPanel from '../../../../components/Editor/EditPanel/TextPanel';
import * as selectors from '../../selectors';

const mapStateToProps = (state: StoreState, ownProps) => {
	return {
		...ownProps,
		fontFamilyOptions: selectors.getFontFamilyOptions(state),
		fontSizeOptions: selectors.getFontSizeOptions(state),
		colorOptions: selectors.getColorOptions(state),
		lineHeightOptions: selectors.getLineHeightOptions(state),
		letterSpacingOptions: selectors.getLetterSpacingOptions(state),
	};
};

export default connect(mapStateToProps)(TextPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/TextPanel/index.tsx